module.exports = __webpack_public_path__ + "static/media/Imagen_4.a8813f1c.jpg";